import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { PrintingPatternQuery, PrintingPatternQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(PrintingPatternQuery)
@Wrapper(PrintingPatternQueryHandlerBase)
export class PrintingPatternQueryHandler {
    public constructor(
        http: Http
    ) { }
}
